import React, { useState } from "react";
import styled from "styled-components";
import RadioGroup from "sushiweb/RadioGroup";
import Input from "sushiweb/InputTypes/Input";
import { Tooltip } from "@material-ui/core";
import Modal from "sushiweb/Modal";
import Carousel from "sushiweb/Carousel";
import {
  BorderedBox,
  FlexContainer,
  Pill,
  FieldsSection,
  Divider,
} from "../../constants/assets/containers";
import QcDriverDocumentDetailFields from "../../constants/QcDetails/QcDocumentDetailFields.json";
import {
  capitalizeFirstLetter,
  getPath,
  isMobile,
  isValNull,
} from "../../utils";
import Toast from "sushiweb/Toast";
import variables from "../../constants/assets/variables";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import AddEdit from "sushiweb/Icons/all/AddEdit";
import CheckCircleFill from "sushiweb/Icons/all/CheckCircleFill";
import CrossCircleFill from "sushiweb/Icons/all/CrossCircleFill";
import { DocImg } from "../../views/QcDetails";
import { getState, getStateList } from "../../store/actions/State";
import DriverDocumentModal from "../Common/DriverDocumentModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setDlRcDetails, updateDlRcField } from "../../store/actions/DlRcDetails";
import moment from "moment";

export const evTypes = ["ELECTRIC(BOV)", "EV"];

const DlRcDocumentDetailsEdit = ({
  details = {},
  initialState = {},
  editableField,
  rejectionReasons,
  docTypes,
  verifiedOptions,
  setEditableField,
  showSingleFieldEditOptions,
  setShowSingleFieldEditOptions,
  setInitialState,
  updateDlRcField,
  setDlRcDetails,
  currentActiveFeId,
  handleVerifiedChange,
  handleRejectionReasonChange,
  handleDocTypeChange,
  dlRcApproved,
  allMenuActions,
  permission,
  showRcDependentFields,
  setShowRcDependentFields
}) => {
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState("");
  const [activeImageItemKey, setActiveImageItemKey] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const Slide = (docData) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleItemClick = () => {
      setIsModalOpen(true);
    };

    const handleModalClose = () => {
      setIsModalOpen(false);
    };

    const heading = "Document submitted";
    const doc_url = docData.src;

    return (
      <div>
        <FlexContainer>
          <DocImg
            src={doc_url}
            cursor="pointer"
            alt="Document Image"
            onClick={handleItemClick}
          />

          <Modal
            className={"full-height-modal"}
            visible={isModalOpen}
            onClose={handleModalClose}
            showCloseIcon={true}
            slideOnMobile
            isCentered
            padding="2rem"
            preventFocus
            title={heading}
          >
            <img
              src={doc_url}
              alt="Document Image"
              style={{ width: 500, height: 500 }}
            />
          </Modal>
        </FlexContainer>
      </div>
    );
  };


  const handleClose = () => {
    setShowModal(false);
  };

  const closeToast = () => {
    setToast(false);
  };

  const handleDocClick = (file, item) => {
    setModalContent(file);
    setShowModal(true);
    setActiveImageItemKey(item);
  };

  const handleEditSingleField = (item) => {
    setEditableField(item.key);
    setShowSingleFieldEditOptions(item.key);
  };

  const handleCrossClick = (item) => {
    setEditableField("");
    setShowSingleFieldEditOptions("");
    const values = JSON.parse(JSON.stringify(initialState));
    const currVal = getPath(details, item.valuePath, "");
    let secondaryVal = "";
    if (item.secondaryKey) {
      secondaryVal = getPath(details, item.valuePath, "")[[item.secondaryKey]];
    }
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][item.valueKey] =
        currVal[item.valueKey];
    }
    if (secondaryVal) {
      values["document_details"][item.key][item.secondaryKey] = secondaryVal;
    }
    setInitialState(values);
  };

  const handleSaveSingleField = (item) => {
    if (!getPath(details, item.valuePath, "")) {
      return;
    }
    const payload = {
        document_details: {
          [item.key]: {
            value: getPath(initialState, item.valuePath, "")[item.valueKey],
            expiry_date: getPath(initialState, item.valuePath, "")["dl_expiry"] || getPath(initialState, item.valuePath, "")["rc_expiry"],
          },
        },
      };
      const newDetails = JSON.parse(JSON.stringify(initialState));
      newDetails["document_details"][item.key][item.valueKey] = payload["document_details"][item.key][item.valueKey];
      newDetails["document_details"][item.key]["expiry"] = payload["document_details"][item.key]["expiry_date"];
      setDlRcDetails(newDetails);
      setEditableField("");
      setShowSingleFieldEditOptions("")
  };

  const handleChange = (item, val, keyToUse = "", isInteger = false) => {
    const values = JSON.parse(JSON.stringify(initialState));
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][keyToUse || item.valueKey] =
        isInteger && val ? Number(val) : val;
    }
    setInitialState(values);
  };

  const handleChangeDate = (item, val, keyToUse) => {
    const values = JSON.parse(JSON.stringify(initialState));
    let value = moment.utc(val.toLocaleString()).format("YYYY-MM-DD");
    if (values["document_details"][item.key]) {
      values["document_details"][item.key][keyToUse] = value;
    }
    setInitialState(values);
  };

  const isIdfyVerified = (field) => {
    return getPath(details, "document_details" + "." + field, "")["idfy_verified"];
  };

  const getRequiredFlag = (field) => {
    return getPath(details, field.valuePath, "")["required"];
  };

  const isEv = (field) => {
    return field === "pucc_doc" && evTypes.includes(getPath(details, "document_details.rc_doc.fuel_type", ""));
  }

  const getCheckList = (field) => {
    switch (field) {
      case "dl_doc": {
        return <dl>
        <dt>Note:</dt>
          <dd>1) License photo should match</dd>
          <dd>2) Name should match</dd>
          <dd>3) Photo should match</dd>
          <dd>4) License should not be expired</dd>
        </dl>
      }
      case "rc_doc": {
        return <dl>
          <dt>Note:</dt>
          <dd>1) Vehicle number should match</dd>
          <dd>2) Fuel type should match</dd>
          <dd>3) RC should not be expired</dd>
        </dl>
      }
      case "insurance_doc": {
        return <dl>
          <dt>Note:</dt>
          <dd>1) Vehicle number should match</dd>
          <dd>2) Insurance should not be expired</dd>
        </dl>
      }
      case "pucc_doc": {
        return <dl>
          <dt>Note:</dt>
          <dd>1) Vehicle number should match</dd>
          <dd>2) Pucc should not be expired</dd>
        </dl>
      
      }
    }
  };

  const getField = (item) => {
    switch (item.type) {
      case "text":
        return (
          <Input
            id="sushi-input"
            data-testId={"Qc" + item.key}
            disabled={true}
            label={item.label}
            fullWidth
            onChange={(e) => handleChange(item, e)}
            value={getPath(initialState, item.valuePath, "")[item.valueKey]}
          />
        );
      case "date":
        return (
            <Input
                id="sushi-input"
                data-testId={"Qc" + item.key}
                type="date"
                disabled={editableField !== item.key}
                label={item.label}
                fullWidth
                onChange={(e) => handleChangeDate(item, e, item.valueKey)}
                value={getPath(initialState, `${item.valuePath}.${item.valueKey}`, "") ? moment(getPath(initialState, item.valuePath, "")[item.valueKey]).format("YYYY-MM-DD") : null}
            />
        );
      default:
        return "";
    }
  };

  const getDropDownForType = (item) => {
    return (
      <PaginatedReactDropdown
        options={getDocTypes(item.key)[0]}
        value={
          getPath(
            initialState,
            QcDriverDocumentDetailFields[item.key].valuePath,
            ""
          ).doc_type
        }
        handleChange={handleDocTypeChange}
        placeholder={
          QcDriverDocumentDetailFields[item.key].placeHolderForDocType
        }
        keyToChange={item}
        extraParams={[
          QcDriverDocumentDetailFields[item.key],
          "document_details",
        ]}
        showCross={true}
        labelWidth="30%"
        marginTop="25px"
        id={`driverQcDocumentDetailsDropdown${item}`}
        disabled={
          dlRcApproved ||
          getPath(initialState, `document_details.${item}.verified`, false)
        }
      />
    );
  };

  const getInfoFields = (key) => {
    switch (key) {
        case "rc_doc":
            return <div><p>Fuel Type: <b>{getPath(initialState, "document_details.rc_doc.fuel_type", "NA").toUpperCase()}</b></p><br/></div>;
        case "dl_doc":
            return <div><p>Name: <b>{getPath(initialState, "basic_details", "")["name"]}</b></p><br/></div>;
        case "pucc_doc":
        case "insurance_doc":
            return <div><p>Vehicle Number: <b>{getPath(initialState, "document_details.rc_doc", "")["value"]}</b></p><br/></div>;
        default:
            return "";
    }
  };  

  const getAdditionalFields = (item) => {
    switch (item.key) {
      case "dl_doc":
        return (
          <form>
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              type="date"
              disabled={true}
              label={"Date of Birth"}
              fullWidth
              onChange={(e) => handleChangeDate(item, e, "dob")}
              value={
                moment(getPath(initialState, "basic_details", "")["dob"]).format("YYYY-MM-DD")
              }
            />
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              type="date"
              disabled={editableField !== item.key}
              label={"License Expiry Date"}
              fullWidth
              onChange={(e) => handleChangeDate(item, e, "dl_expiry")}
              value={getPath(initialState, item.valuePath, "")["expiry"] ? moment(getPath(initialState, item.valuePath, "")["expiry"]).format("YYYY-MM-DD") : null}
            />
          </form>
        );
      case "rc_doc":
        return (
            <Input
              data-testId={"Qc-associated-field-" + item.key}
              id="sushi-input"
              type="date"
              disabled={editableField !== item.key}
              label={"RC Expiry Date"}
              fullWidth
              onChange={(e) => handleChangeDate(item, e, "rc_expiry")}
              value={getPath(initialState, item.valuePath, "")["expiry"] ? moment(getPath(initialState, item.valuePath, "")["expiry"]).format("YYYY-MM-DD") : null}
            />
        );
      default:
        return "";
    }
  };

  const getOptionalPhotoUrl = (activeImageItemKey) => {
    return activeImageItemKey === "dl_doc" ? getPath(initialState, "basic_details.driver_photo.url", "") : "";
  };

  const getOptionalPhotoTitle = (activeImageItemKey) => {
    return activeImageItemKey === "dl_doc" ? "Driver Photo" : "";
  };

  const getDocPhoto = (field) => {
    let url = getPath(
      details,
      QcDriverDocumentDetailFields[field].valuePath,
      ""
    )[QcDriverDocumentDetailFields[field].urlKey];
    return (
      url && (
        <DocImg onClick={() => handleDocClick(url, field)} src={url} alt="" />
      )
    );
  };

  const getRejectionReasons = (key) => {
    if (getPath(Object.keys(rejectionReasons), "length", "")) {
      return rejectionReasons
        .filter((reason) => reason.key === key)
        .map((obj) => obj);
    }
    return [];
  };

  const getDocTypes = (key) => {
    if (getPath(Object.keys(docTypes), "length", "")) {
      return docTypes.map((obj) => obj[key]);
    }
    return [];
  };

  const getModalValue = () => {
    if (activeImageItemKey) {
      if (activeImageItemKey === "pucc_doc" || activeImageItemKey === "insurance_doc") {
        return getPath(initialState, `document_details.${activeImageItemKey}.value`, "") ? moment(getPath(initialState, `document_details.${activeImageItemKey}.value`, "")).format("DD-MM-YYYY") : null;
      }
      return getPath(
        details,
        QcDriverDocumentDetailFields[activeImageItemKey].valuePath,
        ""
      )[QcDriverDocumentDetailFields[activeImageItemKey].valueKey];
    }
    return false;
  };

  const shouldShowEdit = (field) => {
    if (field === "insurance_doc" || field === "pucc_doc") {
      return !getPath(
        initialState,
        "document_details." + field + ".idfy_verified",
        false
      );
    }
    return true;
  };

  const isEditable = (field) => {
    return getPath(
      initialState,
      "document_details." + field + ".editable",
      true
    );
  };

  const showField = (field) => {
    if (field === "bank_doc") {
      return getPath(initialState, "document_details.bank_doc.display", true);
    }
    return true;
  };

  const TickIcon = React.forwardRef(function TickIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref} className="mr-10">
        <CheckCircleFill
          color={variables.primaryColor}
          className="cursor-pointer"
          onClick={() =>
            handleSaveSingleField(QcDriverDocumentDetailFields[props.field])
          }
        />
      </div>
    );
  });

  const CrossIcon = React.forwardRef(function CrossIcon(props, ref) {
    //  Spread the props to the underlying DOM element.
    return (
      <div {...props} ref={ref}>
        {" "}
        <CrossCircleFill
          onClick={() =>
            handleCrossClick(QcDriverDocumentDetailFields[props.field])
          }
          color={variables.primaryColor}
          className="cursor-pointer"
        />
      </div>
    );
  });

  const getVerifiedValue = (key) => {
    var localVerifiedOptions = JSON.parse(JSON.stringify(verifiedOptions));
    return localVerifiedOptions;
  };

  const getRejectionLabel = (field) => {
    const rejectionReasons = getRejectionReasons(field);
    const selectedReason = rejectionReasons.find(reason => reason.error_code === getPath(initialState, `document_details.${field}.rejection_reason`, ""));
    return selectedReason ? selectedReason.reason : "";
  }

  const getModelLabel = (activeImageItemKey) => {
    switch (activeImageItemKey) {
        case "dl_doc":
            return "Driver License Number";
        case "rc_doc":
            return "Vehicle Registration Number";
        case "insurance_doc":
        case "pucc_doc":
            return "Expiry Date";
        default:
            return "";
    }
  };

  const getSortedKeysById = (document_details) => {
    return Object.keys(document_details).sort((a, b) => {
      return document_details[a].id - document_details[b].id;
    });
  }

  const showEvField = (field, index) => {
    return (
      QcDriverDocumentDetailFields[field] &&
      getRequiredFlag(QcDriverDocumentDetailFields[field]) &&
      showField(field) && (
        <FieldsSection key={field + index}>
          <p className="section-heading">
            {QcDriverDocumentDetailFields[field].heading.toUpperCase()}
          </p>
          <BorderedBox className="fields-holder mb-40">
            <FlexContainer align="flex-start">
              <QcDocumentFieldsContainer>
                <FlexContainer align="flex-start">
                  <div
                    className={`w-full ${
                      !QcDriverDocumentDetailFields[field][
                        "noRightMargin"
                      ] && "mr-10"
                    }`}
                  >
                  </div>
                </FlexContainer>
                {
                  getInfoFields(field)
                }
              </QcDocumentFieldsContainer>
                <Pill>{"Verfication Not Required - Electric Vehicle"}</Pill>
            </FlexContainer>
          </BorderedBox>
        </FieldsSection>
      )
    );
  }

  const canShowRcDependentFields = (field) => {
    if(field === "rc_doc"){
      if(getPath(initialState, 'document_details.rc_doc.verified', false)){
        setShowRcDependentFields(true);
      }
    }
    if(field !== "pucc_doc" && field !== "insurance_doc") return true;
    return showRcDependentFields;
  }

  return [
    <QcDriverDocumentDetailsEditContainer>
      {getPath(Object.keys(details), "length", 0) > 0 &&
        getSortedKeysById(details.document_details).map(
          (field, index) => {
            if(!canShowRcDependentFields(field)){
              return;
            }
            if(isEv(field)){
              return showEvField(field, index);
            }
            return (
              QcDriverDocumentDetailFields[field] &&
              getRequiredFlag(QcDriverDocumentDetailFields[field]) &&
              showField(field) && (
                <FieldsSection key={field + index}>
                  <p className="section-heading">
                    {QcDriverDocumentDetailFields[field].heading.toUpperCase()}
                  </p>
                  <BorderedBox className="fields-holder mb-40">
                    <FlexContainer align="flex-start">
                      <QcDocumentFieldsContainer>
                        <FlexContainer align="flex-start">
                          <div
                            className={`w-full ${
                              !QcDriverDocumentDetailFields[field][
                                "noRightMargin"
                              ] && "mr-10"
                            }`}
                          >
                            { getField(QcDriverDocumentDetailFields[field])}
                          </div>
                          {QcDriverDocumentDetailFields[field].isEditable &&
                            isEditable(field) &&
                            !dlRcApproved &&
                            allMenuActions[permission] &&
                            //shouldShowEdit(field) &&
                            (editableField === field &&
                            showSingleFieldEditOptions === field ? (
                              <FlexContainer justify="flex-start">
                                <Tooltip title="Save" arrow placement="top">
                                  <TickIcon field={field} />
                                </Tooltip>
                                <Tooltip title="Cancel" arrow placement="top">
                                  <CrossIcon field={field} />
                                </Tooltip>
                              </FlexContainer>
                            ) : (
                              !showSingleFieldEditOptions && (
                                <AddEdit
                                  className="cursor-pointer"
                                  onClick={() =>
                                    handleEditSingleField(
                                      QcDriverDocumentDetailFields[field]
                                    )
                                  }
                                  color={variables.primaryColor}
                                />
                              )
                            ))}
                        </FlexContainer>
                        {QcDriverDocumentDetailFields[field][
                          "additionalAssociatedField"
                        ] &&
                          getAdditionalFields(
                            QcDriverDocumentDetailFields[field]
                          )}
                        {
                            getInfoFields(field)
                        }
                        { getDocPhoto(field)}
                        {!QcDriverDocumentDetailFields[field][
                          "skipRadioAcceptRejectField"
                        ] && !getPath(
                          initialState,
                          QcDriverDocumentDetailFields[field].valuePath,
                          ""
                        )["idfy_verified"] && (
                          <RadioGroup
                            options={getVerifiedValue(field)}
                            horizontal
                            selectedColor={variables.primaryColor}
                            selected={
                              getPath(
                                initialState,
                                QcDriverDocumentDetailFields[field].valuePath,
                                ""
                              )["verified"]
                            }
                            className="sushi-radios"
                            onChange={(e) =>
                              handleVerifiedChange(
                                QcDriverDocumentDetailFields[field],
                                e,
                                "document_details"
                              )
                            }
                            name={`${field}-verified-options`}
                          />
                        )}
                        {!QcDriverDocumentDetailFields[field][
                          "skipRejectionReasonsField"
                        ] && !getPath(
                          initialState,
                          QcDriverDocumentDetailFields[field].valuePath,
                          ""
                        )["idfy_verified"] && (
                          <PaginatedReactDropdown
                            options={getRejectionReasons(field)}
                            value={
                              getRejectionLabel(field) ||
                              getPath(
                                initialState,
                                QcDriverDocumentDetailFields[field].valuePath,
                                ""
                              ).rejection_reason
                            }
                            labelKey="reason"
                            valueKey="error_code"
                            handleChange={handleRejectionReasonChange}
                            placeholder="Select rejection reason"
                            keyToChange={field}
                            extraParams={[
                              QcDriverDocumentDetailFields[field],
                              "document_details",
                            ]}
                            showCross={true}
                            labelWidth="30%"
                            id={`driverQcDocumentDetailsDropdown${field}`}
                            disabled={
                              dlRcApproved ||
                              getPath(
                                initialState,
                                `document_details.${field}.verified`,
                                false
                              )
                            }
                          />
                        )}
                        {QcDriverDocumentDetailFields[field][
                          "docTypeAssociatedField"
                        ] &&
                          getDropDownForType(
                            QcDriverDocumentDetailFields[field]
                          )}
                      </QcDocumentFieldsContainer>
                      {(field === "pucc_doc" || field === "insurance_doc") &&
                        isIdfyVerified(field) && (
                          <Pill>{"IDFY Verified"}</Pill>
                        )}
                      {!isIdfyVerified(field) && getCheckList(field)}
                    </FlexContainer>
                  </BorderedBox>
                </FieldsSection>
              )
            );
          }
        )}
    </QcDriverDocumentDetailsEditContainer>,
    <DriverDocumentModal
      fullWidthModal={activeImageItemKey != "aadhar_card_doc"}
      optionalPhotoTitle={getOptionalPhotoTitle(activeImageItemKey)}
      optionalPhotoUrl={getOptionalPhotoUrl(activeImageItemKey)}
      showModal={showModal}
      infoFields={getInfoFields(activeImageItemKey)}
      optionalInput={
        Object.keys(activeImageItemKey).length > 0 &&
        getModalValue() && (
          <>
            { 
              <Input
                id="sushi-input"
                data-testId="modalInputVal"
                disabled={true}
                label={
                    getModelLabel(activeImageItemKey)
                }
                value={getModalValue()}
              />
            }
            {QcDriverDocumentDetailFields[activeImageItemKey][
              "additionalAssociatedField"
            ] &&
              getAdditionalFields(
                QcDriverDocumentDetailFields[activeImageItemKey]
              )}
          </>
        )
      }
      handleClose={handleClose}
      modalContent={modalContent}
    />,
    <Toast
      show={toast}
      align="top"
      onClose={closeToast}
      text={toastMessage}
      type="error"
      autoHideDuration={2}
    />,
  ];
};

const QcDriverDocumentDetailsEditContainer = styled(BorderedBox)``;

const QcDocumentFieldsContainer = styled.div`
  flex: ${isMobile() ? " 0 1 100%" : " 0 1 60%"};
  display: flex;
  flex-direction: column;
`;

function mapStateToProps(state) {
  const { DlRcDetails, MenuActions, State } = state;
  return {
    currentActiveFeId: DlRcDetails.currentActiveFeId,
    allMenuActions: MenuActions.allMenuActions,
    nextPageState: State.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateDlRcField: bindActionCreators(updateDlRcField, dispatch),
    setDlRcDetails: bindActionCreators(setDlRcDetails, dispatch),
    getStateList: bindActionCreators(getStateList, dispatch),
    getState: bindActionCreators(getState, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DlRcDocumentDetailsEdit);